<button-field-pds3 type="icon">
    <button
        #sortPopup
        class="wk-sortmenu"
        [attr.aria-pressed]="isPopoverOpen"
        placement="bottom"
        triggers="click"
        [outsideClick]="true"
        [popover]="this.hasPendingFavoriteFilterChanges ? null : sortPopoverContent"
        container="body"
        (click)="onSortButtonClick()"
        (onShown)="isPopoverOpen = true; onPopoverShown()"
        (onHidden)="isPopoverOpen = false"
        (keydown.escape)="closePopover()"
    >
        <wk-icon-swap-vertical-sprite-pds3> </wk-icon-swap-vertical-sprite-pds3>
        <icon-pds3 name="wk-icon-swap-vertical"> </icon-pds3>
    </button>
</button-field-pds3>

<ng-template #sortPopoverContent>
    @if (sortByModel) {
        <div
            #sortPopover
            class="wk-sortmenu__popover"
            tabindex="-1"
            role="dialog"
            aria-modal="true"
            aria-label="Trier"
            cdkTrapFocus
            cdkTrapFocusAutoCapture
        >
            <div class="wk-sortmenu__popover--padding">
                <kendo-dropdownlist-wrapper
                    name="sortBy"
                    flow-id="selectBy"
                    [label]="sortByModel.label"
                    [data]="sortByModel.applicableOptions"
                    [ngModel]="sortByModel.selection?.value"
                    (ngModelChange)="onSortChanged(getSortByOption($event), sortOrderModel.selection, true, true)"
                    textField="text"
                    valueField="value"
                    [filterable]="true"
                >
                </kendo-dropdownlist-wrapper>
            </div>
            <div class="wk-sortmenu__popover--padding">
                <kendo-dropdownlist-wrapper
                    name="selectOrder"
                    flow-id="selectOrder"
                    [label]="sortOrderModel.label"
                    [data]="sortOrderModel.applicableOptions"
                    [ngModel]="sortOrderModel.selection?.value"
                    (ngModelChange)="onSortChanged(sortByModel.selection, getSortOrderOption($event), true, true)"
                    textField="text"
                    valueField="value"
                    [filterable]="true"
                >
                </kendo-dropdownlist-wrapper>
            </div>
        </div>
    }
</ng-template>
